module.exports = __webpack_public_path__ + "fonts/Bitter-Regular.8393e45.ttf";